import { useState, useCallback, useRef, useEffect } from 'react';
import API from 'api/api';
import { translateApiError } from 'i18n/translateApiError';

export function useAssignValidatorToUser() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const mountedRef = useRef(true);

  // Cleanup ref on unmount
  useEffect(() => {
    return () => {
      mountedRef.current = false;
    };
  }, []);

  const assignValidatorToUser = useCallback(async (firebaseUid) => {
    if (!firebaseUid) {
      console.error('No firebaseUid provided to assignValidatorToUser');
      return false;
    }

    try {
      if (mountedRef.current) {
        setLoading(true);
        setError(null);
      }

      const res = await API.patch(`/users/${firebaseUid}/assign-validator`);
      console.log(res.data);
      return res.data; // backend likely returns { message, user }
    } catch (err) {
      if (err.name === 'CanceledError' || err.code === 'ERR_CANCELED')
        return false;
      console.error('Failed to assign validator:', err);
      if (mountedRef.current) {
        setError(translateApiError(err, 'Failed to assign validator'));
      }
      return false;
    } finally {
      if (mountedRef.current) setLoading(false);
    }
  }, []);

  return { assignValidatorToUser, loading, error };
}
